var path = 'app/scripts/modules/openstack/src/common/cacheBackedSelectField.template.html';
var html = "<select-field value=\"model\" options=\"options\"\n              label=\"{{label}}\" label-column-size=\"{{labelColumnSize}}\"\n              value-column-size=\"{{valueColumnSize}}\"\n              help-key=\"{{helpKey}}\" on-change=\"onValueChanged(value)\"\n              read-only=\"readOnly\" allow-no-selection=\"allowNoSelection\"\n              no-options-message=\"{{noOptionsMessage}}\" no-selection-message=\"{{noSelectionMessage}}\"\n              option-update=\"updateOptions\" backing-cache=\"{{backingCache}}\"></select-field>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/openstack/src/common/cacheBackedSelectField.template.html
// module id = 253
// module chunks = 0